import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si no vendo por Instagram?',
  a: 'Sí. Los scripts están diseñados para Instagram DM y WhatsApp, pero la estructura del Mapa 5F funciona en cualquier canal de mensajería directa.'
}, {
  q: '¿Y si mi producto es muy diferente?',
  a: 'Los scripts son plantillas adaptables. Incluyen instrucciones para personalizarlos a cualquier rubro: servicios, productos físicos, cursos, etc.'
}, {
  q: '¿Cuánto tiempo necesito para implementarlo?',
  a: 'Podés empezar a usar los scripts hoy mismo. El Mapa 5F completo se implementa en menos de una semana.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí, tenés 7 días de garantía. Si no te sirve, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Es un curso?',
  a: 'No. Es un kit práctico: scripts, plantillas y una guía paso a paso. Sin videos largos ni módulos interminables. Abrís, copiás, pegás y vendés.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section background="cream" data-id="element-32">
      <div className="text-center mb-12" data-id="element-33">
        <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D]" data-id="element-34">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-35">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#E8E0D5]" data-id="element-36">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-[#FDFBF7] transition-colors" data-id="element-37">
              <span className="font-medium text-[#2D2D2D] text-lg" data-id="element-38">
                {faq.q}
              </span>
              {openIndex === index ? <ChevronUp className="text-[#C5A55A]" data-id="element-39" /> : <ChevronDown className="text-[#C5A55A]" data-id="element-40" />}
            </button>

            <AnimatePresence data-id="element-41">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-42">
                  <div className="px-6 pb-6 text-[#6B6B6B] leading-relaxed border-t border-[#F5F0E8] pt-4" data-id="element-43">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}